import { withInstall } from '../../utils';
import Divider from './src/divider.vue';

export const IDivider = withInstall(Divider); // 增加类型

export default IDivider;
